import { Component } from 'react'
import { Button } from 'antd'

/**
 * 错误边界组件：捕获子组件渲染错误，展示友好的错误提示
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ledger-panel" style={{ maxWidth: 480, margin: '48px auto', padding: 32 }}>
          <h2 className="ledger-page-title" style={{ display: 'block', marginBottom: 12 }}>页面出错了</h2>
          <p style={{ color: '#4a4a4a', marginBottom: 24, fontSize: 14 }}>
            {this.state.error?.message || '发生了未知错误，请刷新页面重试'}
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button type="primary" onClick={this.handleReset}>重试</Button>
            <Button onClick={() => { window.location.href = '/dashboard' }}>返回首页</Button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
